import React from 'react'
import Head from '../../../../layout/head/Head'
import Content from '../../../../layout/content/Content'
// import Hero from './UIpagecomponents/Hero'
import About from './UIpagecomponents/About'
import ChooseUs from './UIpagecomponents/ChooseUs'
import Contact from '../../components/Contact'
import ServiceOffer from './UIpagecomponents/ServiceOffer'
import ImpOfService from './UIpagecomponents/ImpOfService'
import Testimonial from '../components/Testimonial'
import GenericHero from '../components/GenericHero'
import heroimg from '../../../../images/axiom_img/UI_UXPage-images/UIUXimg.png';
import { Icon } from '../../../../components/Component'


const UXPage = () => {
    return (
        <React.Fragment>
            <Head title="Axiom | UI / UX Design"></Head>
            <Content>
                {/* <Hero /> */}
                <GenericHero
                    breadcrumbs={
                        <>
                            SERVICES <Icon name={'chevron-right'} /> Creative & Design Services<Icon name={'chevron-right'} /> UI / UX Design                        </>
                    }
                    title="Elevating your brand through design: User-centered solutions for a meaningful impact"
                    description="UI/UX design expertise: Optimizing usability and driving engagement"
                    buttonText="Contact Now"
                    buttonLink="/contact"
                    heroImage={heroimg} />
                <About />
                <ChooseUs />
                <ServiceOffer />
                <ImpOfService />
                <Contact />
                <Testimonial />
            </Content>
        </React.Fragment>

    )
}

export default UXPage
